import { jwtDecode } from "jwt-decode";

import type { RoleDTO } from "../../common/constants/userRole";
import type { UserDTO } from "../../common/types/UserDTO";

export const TOKEN_KEY = "access_token";

interface TokenType {
  sub: string; // user id - impersonated or actual
  aid: string; // account id - impersonated or actual
  upn: string; // email
  groups: RoleDTO[];
  // act is present when in impersonation mode
  act?: {
    sub: string; // user id
    email: string;
  };
  [key: string]: any;
}

class TokenManager {
  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  }

  setToken(token: string) {
    localStorage.setItem(TOKEN_KEY, token);
  }

  removeToken() {
    localStorage.removeItem(TOKEN_KEY);
  }

  getDecodedToken(): TokenType | undefined {
    const token = this.getToken();
    if (!token) return undefined;

    try {
      return jwtDecode(token);
    } catch {
      // Silently remove any invalid token
      this.removeToken();
      return undefined;
    }
  }

  getUserData() {
    const decodedToken = this.getDecodedToken();

    if (!decodedToken) return undefined;

    const userId = parseInt(decodedToken.sub);
    const userEmail = decodedToken.upn;

    const userData: UserDTO = {
      id: userId,
      email: userEmail,
      accountId: parseInt(decodedToken.aid),
      roles: decodedToken.groups,
    };

    return userData;
  }

  isImpersonationMode() {
    const decodedToken = this.getDecodedToken();
    return Boolean(decodedToken?.act);
  }
}

const tokenManager = new TokenManager();

export default tokenManager;
